import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'descripcion',
    label: i18n('entities.tipoPresupuesto.fields.descripcion'),
    schema: schemas.string(
      i18n('entities.tipoPresupuesto.fields.descripcion'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoPresupuesto.fields.habilitado'),
    schema: schemas.boolean(
      i18n('entities.tipoPresupuesto.fields.habilitado'),
      {},
    ),
  },
  {
    name: 'presupuestosVinculados',
    label: i18n('entities.tipoPresupuesto.fields.presupuestosVinculados'),
    schema: schemas.relationToMany(
      i18n('entities.tipoPresupuesto.fields.presupuestosVinculados'),
      {},
    ),
  },
];